import { React, useState, useEffect } from 'react';
import './HangarDetailedAircraft.scss';
import { useTranslation } from "react-i18next";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import MetaData from "../../common/MetaData/MetaData";
import { DEFAULT_SHOW_MORE_LENGTH } from '../../../helper/constants';
import { SEARCH_RESULTS_ATTRIBUTES } from "../../../helper/constants";
import SearchResults from "../../pages/SearchResults/SearchResults";
import Feature from '../../common/FeatureFlags/Feature/Feature';
import "../SearchResults/SearchResults.scss";
import { useSelector } from "react-redux";
import { notificationEnabledPersona } from "../../../helper/constants";
import { InformationIcon } from "../../pages/SvgIcons/SvgIcons";
import Tooltip from '@mui/material/Tooltip';
import { TABB_TITLE_EVENT_KEYS } from "../../../helper/constants";
import { HANGAR_DETAILED_VIEW, PILOT_VALUE, NON_PILOT_VALUE, RECORDS_PER_PAGE_SEARCH_RESULTS, SORT_COLUMN, SORT_ORDER } from "../../../helper/constants";

const toTitleCase = (id) => {
  const str = String(id ?? "").trim();
  if (!str) return str;
  return str
    .toLowerCase()
    .replace(/(^\s*\S|[-_\s]\S)/g, (match) => match.toUpperCase());
};

const HangarDetailedAircraft = (props) => {
  const { t } = useTranslation();
  const [tabData, setTabData] = useState("");
  const [isprofileEnabled, setIsProfileEnabled] = useState(false);
  const [showMoreVal, setShowMoreVal] = useState(DEFAULT_SHOW_MORE_LENGTH);
  const [hangarMetaData, setHangarMetaData] = useState([]);
  const [isTitleLinkEnabled, setIsTitleLinkEnabled] = useState(true);
  const { userInformation } = useSelector((state) => state.userInformation);
  const [hangarCategoryTabData, setHangarCategoryTabData] = useState([]);
  const [hangarPublicationCount, setHangarPublicationCount] = useState(0);
  const [role, setRole] = useState("");
  const [isPilotView, setIsPilotView] = useState(false);
  const [loading, setLoading] = useState(false);
  const aircraftDetails = useSelector((state) => state.aircraft.aircraftDetails);
  const [currentPage, setCurrentPage] = useState(1);

  //PROFILE CHANGE
  const handleProfileChange = (e) => {
    setIsProfileEnabled(e.target.checked);
    const role = e.target.checked ? PILOT_VALUE : NON_PILOT_VALUE;
    setRole(role);
    fetchHangarPublicationCategory(role);
  };
  //Pagination pageselection
  const onPageSelected = (page) => {
    setCurrentPage(page);
    handleTabClickData(tabData, role, page); // Fetch content for the selected tab when the page changes
  };

  //FETCH HANGAR PUBLICATION CATEGORY DATA
  const handleTabClickData = async (e, role, pageNo) => {
    if (!pageNo) {
      setCurrentPage(1);
    }
    setTabData(e);
    setHangarMetaData([]);
    try {
      const fetchHangarPublicationMetaDataUrl = "/api/techpub/v1/get-hangar-publication-category-details";
      const payload = {
        aircraft_make: aircraftDetails?.aircraft_make,
        aircraft_model: aircraftDetails?.aircraft_model,
        //Uncomment the below line if you want to fetch fms_version for general user
        // fms_version:aircraftDetails?.fms_version,
        fms_version: role === PILOT_VALUE ? aircraftDetails?.fms_version : "",
        category: e,
        role: role,
        pageable: {
          pageNo: pageNo ? pageNo : 1,
          pageSize: RECORDS_PER_PAGE_SEARCH_RESULTS,
          sortBy: SORT_COLUMN,
          sortDir: SORT_ORDER
        }
      };
      const response = await fetch(fetchHangarPublicationMetaDataUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (response.status === 200) {
        setHangarMetaData(data?.message?.result);
      }
      else if (response.status === 400) {
        setHangarMetaData([]);
      }
    } catch (error) {
      console.log("error" + error.message);
    }
  };

  //FETCH HANGAR PUBLICATION CATEGORY
  const fetchHangarPublicationCategory = async (role) => {
    try {
      setLoading(true);
      const fetchHangarPublicationCategoryUrl = "/api/techpub/v1/get-hangar-publication-category";
      const payload = {
        aircraft_make: aircraftDetails?.aircraft_make,
        aircraft_model: aircraftDetails?.aircraft_model,
        //Uncomment the below line if you want to fetch fms_version for general user
        // fms_version:aircraftDetails?.fms_version,
        fms_version: role === PILOT_VALUE ? aircraftDetails?.fms_version : "",
        role: role
      };
      const response = await fetch(fetchHangarPublicationCategoryUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (response.status === 200) {
        setLoading(false);
        setHangarCategoryTabData(data?.message?.result?.publicationCategoryData);
        setTabData(data?.message?.result?.publicationCategoryData[0]?.id);
        const hangarTabData = data?.message?.result?.publicationCategoryData[0]?.id;
        handleTabClickData(hangarTabData, role);
        const hangarPublicationCountData = data?.message?.result?.publicationCategoryData;
        var count = 0;
        hangarPublicationCountData?.forEach((item) => {
          count = count + Number(item.value);
        });
        setHangarPublicationCount(count);
      }
    } catch (error) {
      console.log("error" + error.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    var role;
    if (notificationEnabledPersona.includes(userInformation?.jobTitle.toLowerCase())) {
      setIsProfileEnabled(true);
      role = PILOT_VALUE;
    } else {
      setIsProfileEnabled(false);
      role = NON_PILOT_VALUE;
    }
    setRole(role);
    fetchHangarPublicationCategory(role);


  }, []);
  return (
    <>
      <div className="cls-publicationHeader">
        <div className='row'>
          <div className='col-9'>
            <span className="cls-publicationTitle">{t(HANGAR_DETAILED_VIEW.TITLE)}</span>
            <span className="cls-publicationTitle">  ({hangarPublicationCount}) </span>
          </div>
          {/*Enabling for pilot user also*/}
          <div className='col-3'>
            <div className='cls-toggleView'>
              <label className="cls-switchSection">
                <input type="checkbox" onChange={(e) => handleProfileChange(e)} checked={isprofileEnabled} aria-label='notification-toggle' />
                <span className="cls-switchSlider cls-switchRound"></span>
              </label>
              <span className="cls-switchTitle">{
                role === PILOT_VALUE
                  ? t(HANGAR_DETAILED_VIEW.TOGGLE_GENERAL_USER_TEXT)
                  : t(HANGAR_DETAILED_VIEW.TOGGLE_TEXT)}</span>
              <Tooltip title="Switch to view publication as a pilot/general user." arrow placement="top"
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#384348",
                      fontFamily: "PP Telegraf",
                      fontWeight: "400",
                      color: "#FFFFFF",
                    },
                  },
                  arrow: {
                    sx: {
                      color: "#384348",
                    },
                  },
                }}
              >
                <span><InformationIcon /></span>
              </Tooltip>
            </div>
          </div>

        </div>
      </div>
      {!isprofileEnabled ? (
        <div className='cls-aircraftTabs'>
          {loading ? (
            <div className="cls-loadingContainer">
              <p className="cls-loadingText">{t(HANGAR_DETAILED_VIEW.HANGAR_LOADING)}</p>
            </div>
          ) : hangarCategoryTabData?.length > 0 ? (
            <Tabs
              activeKey={tabData}
              id="uncontrolled-tab-example"
              className="mb-3"
              onSelect={(e) => handleTabClickData(e, role)}
            >

              {hangarCategoryTabData?.map((item, index) => {
                const eventKey = TABB_TITLE_EVENT_KEYS[item?.id.toLowerCase()] || item?.id;
                return (
                  <Tab eventKey={item.id} title={<Tooltip title={toTitleCase(item?.id)} arrow
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#384348",
                          fontFamily: "PP Telegraf",
                          fontWeight: "400",
                          color: "#FFFFFF",
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#384348",
                        },
                      },
                    }}>
                    <span>{`${eventKey} (${item?.value})`}</span>
                  </Tooltip>} key={index} className="cls-hometab">
                    <Feature name="Search Results">
                      <SearchResults
                        dataSearch={hangarMetaData}
                        load={false}
                        showMore={true}
                        attributes={SEARCH_RESULTS_ATTRIBUTES}
                        Watchlistflag={true}
                        className="ViewcollectionContainer TopmetaData"
                        isTitleLink={isTitleLinkEnabled}
                        onPageSelected={onPageSelected}
                        currentPage={currentPage}
                        paginator={true}

                      />
                    </Feature>
                  </Tab>
                );
              })}
            </Tabs>
          ) : (
            <div className="cls-noTabDataContainer">
              <div className="cls-noTabText">{t(HANGAR_DETAILED_VIEW.TABS_NODATA_TEXT)}</div>
            </div>
          )
          }
        </div>
      ) : (<div className='cls-aircraftPilotTabs'>
        {loading ? (
          <div className="cls-loadingContainer">
            <p className="cls-loadingText">{t(HANGAR_DETAILED_VIEW.HANGAR_LOADING)}</p>
          </div>
        ) : hangarCategoryTabData?.length > 0 ? (
          <Tabs
            activeKey={tabData}
            id="uncontrolled-tab-example"
            className="mb-3"
            onSelect={(e) => handleTabClickData(e, role)}
          >
            {hangarCategoryTabData?.map((item, index) => {
              const eventKey = TABB_TITLE_EVENT_KEYS[item?.id.toLowerCase()] || item?.id;
              return (
                <Tab eventKey={item.id} title={<Tooltip title={toTitleCase(item?.id)} arrow
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "#384348",
                        fontFamily: "PP Telegraf",
                        fontWeight: "400",
                        color: "#FFFFFF",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#384348",
                      },
                    },
                  }}
                >
                  <span>{`${eventKey} (${item?.value})`}</span>
                </Tooltip>} key={index} className="cls-hometab">
                  <Feature name="Search Results">
                    <SearchResults
                      dataSearch={hangarMetaData}
                      load={false}
                      showMore={true}
                      attributes={SEARCH_RESULTS_ATTRIBUTES}
                      Watchlistflag={true}
                      className="ViewcollectionContainer TopmetaData"
                      isTitleLink={isTitleLinkEnabled}
                      onPageSelected={onPageSelected}
                      currentPage={currentPage}
                      paginator={true}

                    />
                  </Feature>
                </Tab>
              );
            })}
          </Tabs>
        ) : (
          <div className="cls-noTabDataContainer">
            <div className="cls-noTabText">{t(HANGAR_DETAILED_VIEW.TABS_NODATA_TEXT)}</div>
          </div>
        )
        }
      </div>)
      }
    </>
  );
};
export default HangarDetailedAircraft;